import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Detector } from 'react-detect-offline';
import { Route, HashRouter, useLocation } from 'react-router-dom';
import { CircleSpinner } from 'react-spinners-kit';
import { appReady } from '../actions/appActions';
import { initializeApp } from 'firebase/app';
import { DataManagerProvider } from '../context/DataManager';
import { AssociateRealtimeProvider } from '../context/AssociateRealtimeProvider';
import { useTranslation } from 'react-i18next';

import ContextProvider from '../context/ContextProvider';

import '../css/bootstrap-customization.css';
import '../css/fonts-inter.css';
import '../css/colors.css';
import '../css/style.css';
import OfflineScreen from '../screens/Common/OfflineScreen';

import useScrollHack from '../hooks/useScrollHack.js';

import AppUpdateRequestBanner from './AppUpdateRequestBanner';
import StripeOnboardingRefresh from '../screens/Stripe/Onboarding/StripeOnboardingRefresh.js';
import StripeOnboardingReturn from '../screens/Stripe/Onboarding/StripeOnboardingReturn.js';

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE);

const AppConnect = ({ language }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const location = useLocation();

  const app = useSelector((state) => state.app);
  const firebaseApp = initializeApp(firebaseConfig);
  const [refresh, setRefresh] = useState(false);

  useScrollHack();

  useEffect(() => {
    if (app.language !== null) i18n.changeLanguage(app.language);
  }, [app.language]);

  useEffect(() => {
    dispatch(appReady(language));
  }, []);

  const renderLoading = () => {
    let spinner = (
      <CircleSpinner
        className='spinner-app mx-auto'
        style={{ margin: 'auto' }}
        size={40}
        color='var(--color-font-primary)'
      />
    );
    return (
      <div className='loading-app'>
        <div className='loaderDiv'>{spinner}</div>
      </div>
    );
  };

  const onlinePollingDetector = {
    enabled: true,
    interval: 15000,
    url: `https://status.wellet.fun/`,
  };

  const renderApp = () => {
    return (
      <DataManagerProvider>
        <AssociateRealtimeProvider>
          <ContextProvider key={refresh}>
            <AppUpdateRequestBanner />
            <div className={`main background-app`}>
              <HashRouter location={location} hashType='noslash'>
                <Route
                  path='/onboarding-stripe/refresh'
                  render={(props) => <StripeOnboardingRefresh {...props} />}
                />
                <Route
                  path='/onboarding-stripe/return'
                  render={(props) => <StripeOnboardingReturn {...props} />}
                />
              </HashRouter>
            </div>
          </ContextProvider>
        </AssociateRealtimeProvider>
      </DataManagerProvider>
    );
  };

  return (
    <Detector
      polling={onlinePollingDetector}
      render={({ online }) =>
        online ? (
          <Suspense fallback={renderLoading()}>{renderApp()}</Suspense>
        ) : (
          <div className={'main background-app'}>
            <OfflineScreen />
          </div>
        )
      }
    />
  );
};

export default AppConnect;
